module.exports = __webpack_public_path__ + "img/corehcs_dashboard1.df02be7d.png";